import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography, createStyles, Theme, makeStyles } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme: Theme) => createStyles({
    title: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing(),
    },

    titleContent: {
        margin: 0,
        marginLeft: 8,
        padding: theme.spacing(),
        display: 'flex',
        alignItems: 'center'
    },

    titleIcon: {
        width: 24,
        height: 24,
        color: grey[500],
        marginRight: theme.spacing()
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}))

type Param = {
    titel?: string,
    text: string,
    open: boolean;
    handleOnClose: () => void;
}

const InfoDialog: React.FC<Param> = ({ titel, text, open, handleOnClose }) => {
    const classes = useStyles();
    return <>
        <Dialog
            open={open}
            onClose={handleOnClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            {titel &&
                <DialogTitle id="alert-dialog-title" className={classes.title}>
                    <div className={classes.titleContent}>
                        <Typography variant="h5">{titel}</Typography>
                    </div>

                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleOnClose}>
                        <CloseIcon color='secondary' />
                    </IconButton>

                </DialogTitle>
            }
            <DialogContent>
                <DialogContentText id="alert-dialog-description" component='div'>
                    <Typography color='textPrimary' variant='h6'>{text}</Typography>

                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {/* 
                <Button onClick={() => handleOnClose()} color="primary" autoFocus>OK</Button>
*/}
            </DialogActions>
        </Dialog>
    </>
}

export default InfoDialog;